import { isCustomDomain } from 'shared/utils/is-custom-domain'
import { isSioDomain } from 'shared/utils/is-sio-domain'
import { useBrand } from 'modules/white-label/contexts/brand-context'

interface AuthFormHeaderProps {
  logo?: React.ReactNode
  title: string
  description?: string
}

export const AuthFormHeader = ({ logo, title, description }: AuthFormHeaderProps) => {
  const { brand } = useBrand()

  const showLogo = !isCustomDomain() && isSioDomain()

  return (
    <div className="flex flex-col items-center gap-2 text-center md:gap-3">
      {showLogo &&
        (logo ?? (
          <img
            className="w-[45px] max-w-[45px] md:w-[53px] md:max-w-[53px]"
            src="https://d2543nuuc0wvdg.cloudfront.net/images/logo_small.svg"
            alt={`${brand.name} favicon`}
          />
        ))}
      <p className="text-3xl font-bold tracking-tight text-neutral-400 md:text-4xl xl:text-[42px] 2xl:text-5xl">
        {title}
      </p>
      {description && <p className="text-base text-neutral-300 2xl:text-lg">{description}</p>}
    </div>
  )
}
